import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  accessToken: string | null
  setAccessToken: (token: string) => void
  clearAccessToken: () => void
  isAuthenticated: () => boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      setAccessToken: (token) => set({ accessToken: token }),
      clearAccessToken: () => set({ accessToken: null }),
      isAuthenticated: () => get().accessToken !== null,
    }),
    {
      name: 'sextant-auth',
      partialize: (state) => ({ accessToken: state.accessToken }),
    },
  ),
)
